import React, { useEffect, useState } from "react";
import MenuComponent from "../../components/MenuComponent/MenuComponent";
import Select from "react-select";
import TimLama from "../../Assets/tim-lama.jpeg";
import DeleteIcon from "../../Assets/delete_icon.png";
import CloseLogo from "../../Assets/close_icon.png";
import RefreshIcon from "../../Assets/refresh-icon.png";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import {
  formatDot,
  numberWithCommas,
  switchDotsAndCommas,
  hasRole,
} from "../../util/helperFunction";
import "./Bpb.css";
import { useBpb } from "./useBpb";
import moment from "moment";
import { bulan, tahun, BagianConstant } from "../../util/constant";
import PdfBpb from "../../components/PdfBpb/PdfBpb";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { generateQRWithLogo } from "../../components/generateQrLogo/qr";

// Tampilkan angka dengan titik ribuan (1.250.000) dan koma desimal (2,5)
const formatInputJumlah = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const str = String(value);
  const [intPart, decPart] = str.split(".");
  const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return decPart !== undefined ? `${intFormatted},${decPart}` : intFormatted;
};

// Ambil angka mentah dari ketikan user: "1.250,5" -> "1250.5"
const parseInputJumlah = (text) => {
  const cleaned = String(text).replace(/[^\d,]/g, "");
  const [intPart, ...rest] = cleaned.split(",");
  const intDigits = intPart.replace(/^0+(?=\d)/, "");
  return cleaned.includes(",") ? `${intDigits}.${rest.join("")}` : intDigits;
};

const Bpb = () => {
  const {
    dataUser,
    menu,
    setMenu,
    isCheck,
    setIsCheck,
    dateBpb,
    setDateBpb,
    dariBagian,
    setDariBagian,
    keBagian,
    setKeBagian,
    jumlah,
    setJumlah,
    keterangan,
    setKeterangan,
    produk,
    setProduk,
    handleKirimBpb,
    popUpTambah,
    setPopUpTambah,
    dataTempBpb,
    handlePickBpb,
    popUpPick,
    setPopUpPick,
    dataPick,
    isBarang,
    isJasa,
    handleDeleteBarangPick,
    handleSubmitBpb,
    handleChangeChecklist,
    subMenu,
    setSubMenu,
    handleApprovalBpb,
    dataHeader,
    handlePickJenisBpb,
    dataListNama,
    handleCloseAddBpb,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    subMenuBpb,
    setSubMenuBpb,
    valueSearchBarang,
    setValueSearchBarang,
    dataTempBarang,
    valueSearchJasa,
    setValueSearchJasa,
    dataTempJasa,
    popUpTambahList,
    setPopUpTambahList,
    namaListBarangJasa,
    setNamaListBarangJasa,
    handleDelete,
    satuan,
    setSatuan,
    errIsEmpty,
    popUpImport,
    setPopUpImport,
    handleCloseImport,
    handleCloseNewBarangJasa,
    handleAddNewList,
    handleBulkImportList,
    setFile,
    satuanLain,
    setSatuanLain,
    filterBagian,
    setFilterBagian,
    handleExportBulananBpb,
    setIsRefresh,
    handleExportTemplate,
    handleCancelProcess,
    handleChangeApproval,
    handleDeleteBpb,
    valueSearchItemBpb,
    setValueSearchItemBpb,
    dataFilterListBpb,
    popUpCariBarang,
    setPopUpCariBarang,
    itemCariBpb,
    setItemCariBpb,
    listCariDataBpb,
    setListCariDataBpb,
    filterBulanDariBpb,
    setFilterBulanDariBpb,
    filterTahunDariBpb,
    setFilterTahunDariBpb,
    filterBulanSampaiBpb,
    setFilterBulanSampaiBpb,
    filterTahunSampaiBpb,
    setFilterTahunSampaiBpb,
    handleExportCariBarangBpb,
    mergeArray,
  } = useBpb();

  // ---------- Role (mendukung role string lama maupun array baru) ----------
  const isFinance = hasRole(dataUser, "finance_admin", "super_user");
  const isDireksi = hasRole(dataUser, "direksi_tim");

  const [qrApprover, setQrApprover] = useState(null);
  const [qrRequestor, setQrRequestor] = useState(null);

  let totalReview = dataHeader && dataHeader.totalReview;
  let totalProses = dataHeader && dataHeader.totalProses;
  let totalDone = dataHeader && dataHeader.totalDone;
  let totalMonthToMonth = dataHeader && dataHeader.pertambahanRequest;

  const customStyles = {
    option: (provided) => ({
      ...provided,
      color: "black",
    }),
    control: (provided) => ({
      ...provided,
      color: "black",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const sortDataBarang =
    dataTempBarang &&
    dataTempBarang.sort(function (a, b) {
      if (a.value < b.value) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      }
      return 0;
    });

  const sortDataJasa =
    dataTempJasa &&
    dataTempJasa.sort(function (a, b) {
      if (a.value < b.value) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      }
      return 0;
    });

  useEffect(() => {
    if (dataPick) {
      const approverTemp = dataPick.approver
        ? `${dataPick.approver}, ${moment(dataPick.date)
            .utcOffset("+0700")
            .format("DD-MM-YYYY")}`
        : "";

      const requestorTemp = dataPick.requestor
        ? `${dataPick.requestor}, ${moment(dataPick.date)
            .utcOffset("+0700")
            .format("DD-MM-YYYY")}`
        : "";

      async function createQR() {
        const resultApprover = approverTemp
          ? await generateQRWithLogo(approverTemp)
          : null;

        const resultRequestor = requestorTemp
          ? await generateQRWithLogo(requestorTemp)
          : null;

        setQrApprover(resultApprover);
        setQrRequestor(resultRequestor);
      }

      createQR();
    }
  }, [dataPick]);

  return (
    <>
      {dataUser !== null ? <MenuComponent setMenu={setMenu} menu={menu} /> : ""}
      {popUpPick ? (
        <PopUpComponent className="wrapper_popup_pick" style={{ width: "90%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "6px",
            }}
          >
            <div style={{ display: "flex", gap: "12px" }}>
              <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                <b>{dataPick.dari.toUpperCase()}</b>&nbsp;&nbsp;
              </p>
              <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                {moment(dataPick.date)
                  .utcOffset(7)
                  .format("DD-MM-YYYY, HH:mm:ss")}
              </p>
              <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                <b>No.BPB :</b> {dataPick.bpbNumber}
              </p>
            </div>
            {subMenu !== "review" ? (
              <div
                className="mobile-none-bpb"
                data={dataPick}
                style={{ padding: "6px" }}
              >
                <PDFDownloadLink
                  document={
                    <PdfBpb
                      data={dataPick}
                      qrApprover={qrApprover}
                      qrRequestor={qrRequestor}
                    />
                  }
                  fileName={`BPB No.${dataPick.bpbNumber} ${dataPick.dari}.pdf`}
                >
                  {({ blob, url, loading, error }) =>
                    loading ? "Loading document..." : "Cetak"
                  }
                </PDFDownloadLink>
              </div>
            ) : (
              ""
            )}
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => {
                setPopUpPick(false);
                setQrApprover(null);
                setQrRequestor(null);
              }}
              alt="edit_logo"
            />
          </div>
          {subMenu !== "review" ? (
            <div className="desktop-none title-form-bpb">
              <PDFDownloadLink
                document={<PdfBpb data={dataPick} />}
                fileName="BPB.pdf"
              >
                {({ blob, url, loading, error }) =>
                  loading ? "Loading document..." : "Cetak"
                }
              </PDFDownloadLink>
            </div>
          ) : (
            ""
          )}
          <div
            style={{
              overflow: "scroll",
              background: "#e5f4d4",
              borderRadius: "8px",
              marginTop: "12px",
            }}
          >
            <table
              className="font10-mobile-bpb"
              style={{ width: "100%", borderSpacing: 0 }}
            >
              <tr style={{ textAlign: "left" }}>
                <th style={{ padding: "12px 0" }}></th>
                <th
                  style={{
                    padding: "12px 0",
                    textAlign: "center",
                    borderRight: "1px solid lightgray",
                  }}
                >
                  No.
                </th>
                <th
                  style={{
                    padding: "12px 6px 12px 6px",
                    borderRight: "1px solid lightgray",
                  }}
                >
                  Item
                </th>
                <th
                  style={{
                    padding: "12px 6px 12px 6px",
                    borderRight: "1px solid lightgray",
                    textAlign: "center",
                  }}
                >
                  Jml
                </th>
                <th
                  style={{
                    padding: "12px 6px 12px 6px",
                    borderRight: "1px solid lightgray",
                  }}
                >
                  Satuan
                </th>
                <th
                  style={{
                    padding: "12px 6px 12px 6px",
                    borderRight: "1px solid lightgray",
                  }}
                >
                  Jenis
                </th>
                <th
                  style={{
                    padding: "12px 6px 12px 6px",
                    borderRight: "1px solid lightgray",
                  }}
                >
                  Keterangan
                </th>
                <th
                  style={
                    subMenu !== "review"
                      ? {
                          padding: "12px 6px 12px 6px",
                          borderRight: "1px solid lightgray",
                        }
                      : { display: "none" }
                  }
                >
                  Status
                </th>
                <th
                  style={
                    subMenu !== "review"
                      ? {
                          padding: "12px 6px 12px 6px",
                          borderRight: "1px solid lightgray",
                        }
                      : { display: "none" }
                  }
                >
                  Estimasi
                </th>
                {subMenu !== "review" ? (
                  <>
                    <th
                      style={{
                        padding: "12px 6px",
                        borderRight: "1px solid lightgray",
                      }}
                    >
                      Realisasi
                    </th>
                    <th
                      style={{
                        padding: "12px 6px",
                        borderRight: "1px solid lightgray",
                      }}
                    >
                      Catatan
                    </th>
                    <th style={{ padding: "12px" }}>PO</th>
                  </>
                ) : (
                  ""
                )}
              </tr>
              {dataPick &&
                dataPick.items.map((ele, index) => (
                  <tr
                    style={
                      !ele.isBeli
                        ? { background: "pink" }
                        : index % 2 === 0
                        ? { background: "white" }
                        : { background: "#F7F7F7" }
                    }
                  >
                    {isFinance || (isDireksi && subMenu === "review") ? (
                      <td
                        style={{ padding: "12px 0", textAlign: "right" }}
                        onClick={(e) => handleChangeChecklist(index, e, ele)}
                      >
                        <input
                          style={{
                            height: "18px",
                            width: "18px",
                            margin: "0 6px 0 0",
                          }}
                          type="checkbox"
                          name={
                            subMenu === "review"
                              ? "isBeli"
                              : subMenu === "proccess"
                              ? "isRealisasi"
                              : ""
                          }
                          checked={
                            subMenu === "review"
                              ? ele.isBeli
                              : subMenu === "proccess"
                              ? ele.isRealisasi
                              : ele.isRealisasi
                          }
                        />
                      </td>
                    ) : (
                      <td />
                    )}
                    <td
                      style={{
                        padding: "12px 0",
                        textAlign: "center",
                        borderRight: "1px solid lightgray",
                      }}
                    >
                      {index + 1}.
                    </td>
                    <td
                      style={{
                        padding: "12px 6px 12px 6px",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid lightgray",
                      }}
                    >
                      {!isDireksi && subMenu === "proccess" ? (
                        <div className="select-bpb-ganti-nama">
                          <Select
                            styles={customStyles}
                            menuPosition="fixed"
                            className={
                              !errIsEmpty
                                ? "select-item-bpb"
                                : "select-item-bpb err-empty"
                            }
                            options={
                              ele.jenis === "Barang"
                                ? dataListNama && dataListNama.listNamaBarang
                                : dataListNama && dataListNama.listNamaJasa
                            }
                            value={
                              ele.item
                                ? { label: ele.item, value: ele.item }
                                : null
                            }
                            onChange={(val) =>
                              ele.isBeli
                                ? handleChangeChecklist(
                                    index,
                                    {
                                      target: {
                                        name: "item",
                                        value: val ? val.value : "",
                                      },
                                    },
                                    ele
                                  )
                                : ""
                            }
                          />
                        </div>
                      ) : (
                        <>{ele.item}</>
                      )}
                    </td>
                    <td
                      style={{
                        padding: "0px 6px",
                        borderRight: "1px solid lightgray",
                        textAlign: "center",
                      }}
                    >
                      {subMenu === "review" && isDireksi ? (
                        <input
                          type="text"
                          inputMode="decimal"
                          name="jumlah"
                          className="input-jumlah-approval"
                          value={formatInputJumlah(ele.jumlah)}
                          onChange={(e) =>
                            handleChangeApproval(
                              {
                                target: {
                                  name: "jumlah",
                                  value: parseInputJumlah(e.target.value),
                                },
                              },
                              index
                            )
                          }
                        />
                      ) : (
                        <>{formatDot(ele.jumlah)}</>
                      )}
                    </td>

                    <td
                      style={{
                        padding: "12px 6px 12px 6px",
                        borderRight: "1px solid lightgray",
                      }}
                    >
                      {ele.satuan}
                    </td>
                    <td
                      style={{
                        padding: "12px 6px 12px 6px",
                        borderRight: "1px solid lightgray",
                      }}
                    >
                      {ele.jenis.toUpperCase()}
                    </td>
                    <td
                      style={{
                        padding: "12px 6px 12px 6px",
                        whiteSpace: "nowrap",
                        borderRight: "1px solid lightgray",
                      }}
                    >
                      {ele.keterangan}
                    </td>
                    <td
                      style={
                        subMenu !== "review"
                          ? {
                              padding: "12px 6px 12px 6px",
                              borderRight: "1px solid lightgray",
                            }
                          : {
                              display: "none",
                              borderRight: "1px solid lightgray",
                            }
                      }
                    >
                      {ele.isBeli && dataPick.approver && subMenu === "proccess"
                        ? "Diterima"
                        : !ele.isBeli &&
                          dataPick.approver &&
                          subMenu === "proccess"
                        ? "Ditolak"
                        : ele.isBeli && subMenu === "done"
                        ? "Diterima"
                        : !ele.isBeli && subMenu === "done"
                        ? "Ditolak"
                        : ""}
                    </td>
                    <td
                      style={
                        subMenu !== "review"
                          ? {
                              padding: "12px 0px 12px 6px",
                              borderRight: "1px solid lightgray",
                            }
                          : {
                              display: "none",
                              borderRight: "1px solid lightgray",
                            }
                      }
                    >
                      {ele.isBeli && isFinance ? (
                        <input
                          type="date"
                          className="input-date-bpb"
                          style={{ marginRight: "6px" }}
                          value={ele.estimasi}
                          name="estimasi"
                          onChange={(e) => handleChangeChecklist(index, e, ele)}
                        />
                      ) : (
                        ""
                      )}
                    </td>
                    {subMenu !== "review" ? (
                      <>
                        <td
                          style={{
                            padding: "12px 6px",
                            borderRight: "1px solid lightgray",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {ele.isRealisasi && subMenu === "proccess" ? (
                            <input
                              type="date"
                              className="input-date-bpb"
                              value={ele.realisasiDate}
                              name="realisasiDate"
                              onChange={(e) =>
                                handleChangeChecklist(index, e, ele)
                              }
                            />
                          ) : ele.isRealisasi &&
                            subMenu === "done" &&
                            ele.realisasiDate ? (
                            moment(ele.realisasiDate)
                              .utcOffset("+0700")
                              .format("DD-MM-YYYY")
                          ) : (
                            ""
                          )}
                        </td>
                        {isFinance ? (
                          <>
                            <td
                              style={{
                                padding: "12px 6px",
                                borderRight: "1px solid lightgray",
                              }}
                            >
                              <textarea
                                className="textarea-catatan"
                                onChange={(e) =>
                                  handleChangeChecklist(index, e, ele)
                                }
                                value={ele.catatan ? ele.catatan : ""}
                                name="catatan"
                                placeholder="Catatan"
                              />
                            </td>
                            <td
                              style={{ padding: "12px" }}
                              onClick={
                                subMenu === "proccess" || subMenu === "done"
                                  ? (e) => handleChangeChecklist(index, e, ele)
                                  : () => {}
                              }
                            >
                              <input
                                style={{
                                  height: "18px",
                                  width: "18px",
                                  margin: "0 6px 0 0",
                                }}
                                type="checkbox"
                                name="isPo"
                                checked={ele.isPo ? ele.isPo : false}
                              />
                            </td>
                            {ele.isBeli ? (
                              <td
                                style={{ padding: "12px" }}
                                onClick={
                                  subMenu === "proccess"
                                    ? (e) => handleCancelProcess(ele, dataPick)
                                    : () => {}
                                }
                              >
                                <button className="button-cancel-bpb">
                                  Cancel
                                </button>
                              </td>
                            ) : (
                              <td />
                            )}
                          </>
                        ) : (
                          <>
                            <td
                              style={{ borderRight: "1px solid lightgray" }}
                            ></td>
                            <td></td>
                          </>
                        )}
                      </>
                    ) : (
                      <td style={{ padding: "12px" }}></td>
                    )}
                  </tr>
                ))}
            </table>
          </div>
          {isFinance || (isDireksi && subMenu === "review") ? (
            <div
              className="wrapper-button-tambah-bpb"
              style={{
                margin: "12px 0 0 0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                onClick={() => handleApprovalBpb()}
                className="button-tambah-bpb font10-mobile-bpb"
                style={{ background: "#4ca756", color: "white" }}
              >
                {subMenu === "review"
                  ? "Approve"
                  : subMenu === "done"
                  ? "Buat PO"
                  : "Kirim Data"}
              </button>
            </div>
          ) : (
            ""
          )}
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpTambah ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            height: "90vh",
            width: "88%",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "6px",
            }}
          >
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => handleCloseAddBpb()}
              alt="edit_logo"
            />
          </div>
          <div className="overflow-container-mobile">
            <div
              style={{
                background: "#0e5d5a",
                borderRadius: "6px",
                padding: "6px 8px 12px 8px",
              }}
            >
              <div className="wrapper-input-bpb">
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Pilih Tanggal
                  </p>
                  <input
                    type="date"
                    className="input-date-bpb"
                    value={dateBpb}
                    onChange={(e) => setDateBpb(e.target.value)}
                  />
                </div>
                <div
                  className={
                    !errIsEmpty
                      ? "checkbox-bpb checkbox-barang-jasa-mobile"
                      : "checkbox-bpb checkbox-barang-jasa-mobile err-empty"
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "6px",
                    }}
                    onClick={() => handlePickJenisBpb("barang")}
                  >
                    <input
                      className="checkbox-barang-jasa"
                      type="checkbox"
                      checked={isBarang}
                    />
                    <label>Barang</label>
                  </div>
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    onClick={() => handlePickJenisBpb("jasa")}
                  >
                    <input
                      className="checkbox-barang-jasa"
                      type="checkbox"
                      checked={isJasa}
                    />
                    <label>Jasa</label>
                  </div>
                </div>
                <div
                  className="checkbox-bpb"
                  onClick={() =>
                    isCheck ? setIsCheck(false) : setIsCheck(true)
                  }
                >
                  <input
                    className="checkbox-barang-jasa"
                    type="checkbox"
                    checked={isCheck}
                  />
                  <label>
                    Nama {isBarang ? "Barang" : isJasa ? "Jasa" : ""} sudah ada
                  </label>
                </div>
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Dari :
                  </p>
                  <select
                    defaultValue="Dari Bagian :"
                    className={
                      !errIsEmpty ? "select-bpb" : "select-bpb err-empty"
                    }
                    onChange={(e) => setDariBagian(e.target.value)}
                    value={dariBagian}
                  >
                    <option selected={dariBagian === ""} disabled>
                      Dari Bagian :
                    </option>
                    {BagianConstant.map((obj) => {
                      return <option value={obj.value}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Ke :
                  </p>
                  <select
                    className={
                      !errIsEmpty ? "select-bpb" : "select-bpb err-empty"
                    }
                    defaultValue="Ke Bagian :"
                    onChange={(e) => setKeBagian(e.target.value)}
                    value={keBagian}
                  >
                    <option selected={keBagian || ""} disabled>
                      Ke Bagian :
                    </option>
                    {BagianConstant.map((obj) => {
                      return <option value={obj.value}>{obj.name}</option>;
                    })}
                  </select>
                </div>
              </div>
              <div className="wrapper-input-bpb">
                <div className="select-barang-bpb">
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Nama Barang
                  </p>

                  {isCheck ? (
                    <Select
                      styles={customStyles}
                      className={
                        !errIsEmpty
                          ? "select-item-bpb"
                          : "select-item-bpb err-empty"
                      }
                      options={
                        isBarang
                          ? dataListNama && dataListNama.listNamaBarang
                          : isJasa
                          ? dataListNama && dataListNama.listNamaJasa
                          : []
                      }
                      value={produk || ""}
                      onChange={setProduk}
                    />
                  ) : (
                    <input
                      className={
                        !errIsEmpty
                          ? "input-date-bpb input-nama-barang-bpb"
                          : "input-date-bpb input-nama-barang-bpb err-empty"
                      }
                      type="text"
                      placeholder="Nama Barang"
                      value={produk ? produk : ""}
                      onChange={(e) => setProduk(e.target.value.toUpperCase())}
                      onWheel={(e) => e.target.blur()}
                    />
                  )}
                </div>
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Jumlah
                  </p>
                  <input
                    className={
                      !errIsEmpty
                        ? "input-date-bpb"
                        : "input-date-bpb err-empty"
                    }
                    type="number"
                    placeholder="Jumlah"
                    style={{
                      width: "58px",
                      padding: "0 0 0 6px",
                    }}
                    value={jumlah ? jumlah : ""}
                    onChange={(e) => setJumlah(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Satuan
                  </p>
                  <select
                    className={
                      !errIsEmpty ? "select-bpb" : "select-bpb err-empty"
                    }
                    defaultValue="Satuan"
                    onChange={(e) => setSatuan(e.target.value)}
                    value={satuan}
                  >
                    <option selected={satuan || ""} disabled>
                      Satuan
                    </option>
                    {/* {sortDataSatuan&&sortDataSatuan.map((e) => ( */}
                    {dataListNama &&
                      dataListNama.listSatuan.map((e) => (
                        <option value={e.value}>{e.label}</option>
                      ))}
                    <option value="LAINNYA">LAINNYA</option>
                  </select>
                </div>
                {satuan === "LAINNYA" ? (
                  <div style={{ marginRight: "6px" }}>
                    <p
                      className="font10-mobile-bpb"
                      style={{ margin: "6px 0" }}
                    >
                      Nama Satuan
                    </p>
                    <input
                      className={
                        !errIsEmpty
                          ? "input-date-bpb"
                          : "input-date-bpb err-empty"
                      }
                      type="text"
                      placeholder="Satuan"
                      style={{
                        padding: "0 0 0 6px",
                      }}
                      value={satuanLain}
                      onChange={(e) =>
                        setSatuanLain(e.target.value.toUpperCase())
                      }
                    />
                  </div>
                ) : (
                  ""
                )}
                <div style={{ marginRight: "6px" }}>
                  <p className="font10-mobile-bpb" style={{ margin: "6px 0" }}>
                    Keterangan
                  </p>
                  <input
                    className={
                      !errIsEmpty
                        ? "input-date-bpb input-keterangan-bpb"
                        : "input-date-bpb input-keterangan-bpb err-empty"
                    }
                    type="text"
                    placeholder="Keterangan"
                    value={keterangan ? keterangan : ""}
                    onChange={(e) =>
                      setKeterangan(e.target.value.toUpperCase())
                    }
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div
                  className="wrapper-button-tambah-bpb"
                  style={{ marginRight: "6px" }}
                  onClick={() => handleKirimBpb()}
                >
                  <p></p>
                  <button className="button-tambah-bpb font10-mobile-bpb">
                    Tambah
                  </button>
                </div>
              </div>
            </div>
            <div style={{ marginBottom: "32px" }}>
              <p className="title-form-bpb">Form-PUR-A3-R2</p>
              <div
                style={{
                  display: "flex",
                  marginBottom: "12px",
                  alignItems: "center",
                }}
              >
                <img src={TimLama} className="img-tim-bpb" />
                <p className="title-bpb">
                  Bon Permintaan Barang dan Jasa (BPB)
                </p>
              </div>
              <div className="wrapper-table-popup-pick">
                <table
                  style={{
                    width: "100%",
                    borderSpacing: 0,
                  }}
                >
                  <tr style={{ color: "white" }}>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 0 12px 4px",
                      }}
                    >
                      No.
                    </th>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 6px",
                        textAlign: "left",
                      }}
                    >
                      Item
                    </th>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 6px",
                        textAlign: "center",
                      }}
                    >
                      Jumlah
                    </th>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 6px",
                        textAlign: "left",
                      }}
                    >
                      Keterangan
                    </th>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 6px",
                        textAlign: "left",
                      }}
                    >
                      Jenis
                    </th>
                    <th
                      className="font10-mobile-bpb"
                      style={{
                        borderBottom: "1px solid lightgray",
                        padding: "12px 6px",
                        textAlign: "left",
                      }}
                    >
                      Satuan
                    </th>

                    <th style={{ borderBottom: "1px solid lightgray" }}></th>
                  </tr>

                  {dataTempBpb &&
                    dataTempBpb.map((data, index) => {
                      return (
                        <tr
                          style={
                            index % 2 === 0
                              ? { background: "#F7F7F7" }
                              : { background: "#f2f2f2" }
                          }
                          key={index}
                        >
                          <td className="number-table-bpb font10-mobile-bpb">
                            {index + 1}.
                          </td>
                          <td
                            className="td-table-bpb font10-mobile-bpb"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {data.item}
                          </td>
                          <td
                            className="td-table-bpb font10-mobile-bpb"
                            style={{ textAlign: "center" }}
                          >
                            {formatDot(
                              switchDotsAndCommas(numberWithCommas(data.jumlah))
                            )}
                          </td>
                          <td
                            className="td-table-bpb font10-mobile-bpb"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {data.keterangan}
                          </td>
                          <td className="td-table-bpb font10-mobile-bpb">
                            {data.jenis}
                          </td>
                          <td className="td-table-bpb font10-mobile-bpb">
                            {data.satuan}
                          </td>
                          <td
                            className="td-table-bpb font10-mobile-bpb"
                            onClick={() => handleDeleteBarangPick(data.id)}
                          >
                            <img className="img-delete-bpb" src={DeleteIcon} />
                          </td>
                        </tr>
                      );
                    })}
                </table>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                className="button-kirim-bpb"
                onClick={() => handleSubmitBpb()}
              >
                Kirim
              </button>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpTambahList ? (
        <PopUpComponent>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "6px",
            }}
          >
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => handleCloseNewBarangJasa()}
              alt="edit_logo"
            />
          </div>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "6px",
                marginBottom: "6px",
              }}
              onClick={() => handlePickJenisBpb("barang")}
            >
              <input
                className="checkbox-barang-jasa"
                type="checkbox"
                checked={isBarang}
              />
              <label>Barang</label>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "6px",
              }}
              onClick={() => handlePickJenisBpb("jasa")}
            >
              <input
                className="checkbox-barang-jasa"
                type="checkbox"
                checked={isJasa}
              />
              <label style={{ marginRight: "6px" }}>Jasa</label>
            </div>
            <input
              className="input-nama-barang-bpb"
              style={{ height: "24px" }}
              type="text"
              placeholder={`Nama ${isBarang ? "Barang" : isJasa ? "Jasa" : ""}`}
              value={namaListBarangJasa}
              onChange={(e) =>
                setNamaListBarangJasa(e.target.value.toUpperCase())
              }
            />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              style={{ marginTop: "6px" }}
              className="button-kirim-bpb"
              onClick={() => handleAddNewList()}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpImport ? (
        <PopUpComponent>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "6px",
            }}
          >
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => handleCloseImport()}
              alt="edit_logo"
            />
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "12px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "6px",
                marginBottom: "6px",
              }}
              onClick={() => handlePickJenisBpb("barang")}
            >
              <input
                className="checkbox-barang-jasa"
                type="checkbox"
                checked={isBarang}
              />
              <label>Barang</label>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "6px",
              }}
              onClick={() => handlePickJenisBpb("jasa")}
            >
              <input
                className="checkbox-barang-jasa"
                type="checkbox"
                checked={isJasa}
              />
              <label style={{ marginRight: "6px" }}>Jasa</label>
            </div>
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => setFile(e.target.files[0])}
              style={{ cursor: "pointer" }}
            />
            <button
              style={{ background: "#81bfda" }}
              className="button-kirim-bpb"
              onClick={() => handleExportTemplate()}
            >
              Download Template
            </button>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              style={{ marginTop: "24px" }}
              className="button-kirim-bpb"
              onClick={() => handleBulkImportList()}
            >
              Import
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpCariBarang ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            width: "80%",
            overflowY: "scroll",
            padding: "12px",
            height: "90vh",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "16px",
                width: "90%",
              }}
            >
              <div style={{ width: "30%" }}>
                <p style={{ margin: "6px 0" }}>Nama Item</p>
                <Select
                  styles={customStyles}
                  options={mergeArray}
                  value={itemCariBpb || ""}
                  onChange={setItemCariBpb}
                />
              </div>
              <div>
                <p style={{ margin: "6px 0" }}>Dari</p>
                <div style={{ display: "flex", gap: "16px" }}>
                  <select
                    style={{ height: "32px" }}
                    value={filterBulanDariBpb}
                    onChange={(e) => setFilterBulanDariBpb(e.target.value)}
                  >
                    <option>Bulan</option>
                    {bulan.map((obj) => (
                      <option value={obj.value}>{obj.name}</option>
                    ))}
                  </select>
                  <select
                    style={{ height: "32px" }}
                    value={filterTahunDariBpb}
                    onChange={(e) => setFilterTahunDariBpb(e.target.value)}
                  >
                    <option>Tahun</option>
                    {tahun.map((obj) => (
                      <option value={obj}>{obj}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <p style={{ margin: "6px 0" }}>Sampai</p>
                <div style={{ display: "flex", gap: "16px" }}>
                  <select
                    style={{ height: "32px" }}
                    value={filterBulanSampaiBpb}
                    onChange={(e) => setFilterBulanSampaiBpb(e.target.value)}
                  >
                    <option>Bulan</option>
                    {bulan.map((obj) => (
                      <option value={obj.value}>{obj.name}</option>
                    ))}
                  </select>
                  <select
                    style={{ height: "32px" }}
                    value={filterTahunSampaiBpb}
                    onChange={(e) => setFilterTahunSampaiBpb(e.target.value)}
                  >
                    <option>Tahun</option>
                    {tahun.map((obj) => (
                      <option value={obj}>{obj}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "end" }}>
                <button
                  className="button-create-po"
                  style={{ backgroundColor: "green", margin: "6px 0" }}
                  onClick={() => handleExportCariBarangBpb()}
                >
                  Export
                </button>
              </div>
            </div>
            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => {
                setFilterBulanDariBpb(moment().utcOffset("+0700").month() + 1);
                setFilterTahunDariBpb(moment().utcOffset("+0700").year());
                setFilterBulanSampaiBpb(
                  moment().utcOffset("+0700").month() + 1
                );
                setFilterTahunSampaiBpb(moment().utcOffset("+0700").year());
                setItemCariBpb();
                setListCariDataBpb();
                setPopUpCariBarang(false);
              }}
              alt="edit_logo"
            />
          </div>

          <div
            style={{
              overflow: "scroll",
              background: "#e5f4d4",
              borderRadius: "8px",
              marginTop: "12px",
            }}
          >
            <table
              className="font10-mobile-bpb"
              style={{ width: "100%", borderSpacing: 0, textAlign: "left" }}
            >
              <tr>
                <th style={{ padding: "8px" }}>No.</th>
                <th style={{ padding: "8px" }}>No. BPB</th>
                <th style={{ padding: "8px" }}>Tgl</th>
                <th style={{ padding: "8px" }}>Dari</th>
                <th style={{ padding: "8px" }}>Ke</th>
                <th style={{ padding: "8px" }}>Item</th>
                <th style={{ padding: "8px", textAlign: "center" }}>Jumlah</th>
                <th style={{ padding: "8px" }}>Satuan</th>
                <th style={{ padding: "8px" }}>Realisasi</th>
                <th style={{ padding: "8px" }}>Keterangan</th>
              </tr>
              {listCariDataBpb &&
                listCariDataBpb.map((ele, index) => (
                  <tr
                    style={
                      index % 2 === 0
                        ? { background: "white" }
                        : { background: "#F7F7F7" }
                    }
                  >
                    <td style={{ padding: "8px" }}>{index + 1}.</td>
                    <td style={{ padding: "8px" }}>{ele.bpbNumber}</td>
                    <td style={{ padding: "8px" }}>
                      {moment(ele.date).utcOffset(7).format("DD-MM-YYYY")}
                    </td>
                    <td style={{ padding: "8px" }}>{ele.dari}</td>
                    <td style={{ padding: "8px" }}>{ele.ke}</td>
                    <td style={{ padding: "8px" }}>{ele.item}</td>
                    <td style={{ padding: "8px", textAlign: "center" }}>
                      {formatDot(ele.jumlah)}
                    </td>
                    <td style={{ padding: "8px" }}>{ele.satuan}</td>
                    <td style={{ padding: "8px" }}>
                      {ele.realisasiDate
                        ? moment(ele.realisasiDate)
                            .utcOffset("+0700")
                            .format("DD-MM-YYYY")
                        : ""}
                    </td>
                    <td style={{ padding: "8px" }}>{ele.keterangan}</td>
                  </tr>
                ))}
            </table>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <div className="container-bpb">
        <>
          <div className="wrapper-bpb">
            {!isDireksi ? (
              <div className="wrapper_sub_menu_bpb">
                <p
                  className={
                    subMenuBpb === "bpb"
                      ? "sub_menu_bpb border_active_bpb"
                      : "sub_menu_bpb"
                  }
                  onClick={() => setSubMenuBpb("bpb")}
                >
                  BPB
                </p>
                <p
                  className={
                    subMenuBpb === "list"
                      ? "sub_menu_bpb border_active_bpb"
                      : "sub_menu_bpb"
                  }
                  onClick={() => setSubMenuBpb("list")}
                >
                  List
                </p>
              </div>
            ) : (
              ""
            )}
            {subMenuBpb === "bpb" ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <label style={{ fontWeight: "550", fontSize: "18px" }}>
                    List BPB
                  </label>
                  {isDireksi ? (
                    ""
                  ) : (
                    <div
                      className="wrapper-button-tambah"
                      onClick={() => setPopUpTambah(true)}
                    >
                      <p className="button-tambah">+</p>
                      <button className="text-button-tambah">New BPB</button>
                    </div>
                  )}
                </div>

                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  <div className="wrapper-card-akumulasi">
                    <label className="label-text-bpb">a</label>
                    <div>
                      <p style={{ margin: "6px 0 12px 0" }}>Total Request</p>
                      <p className="total-request-text">
                        {totalReview + totalProses + totalDone} Request
                      </p>
                      <p style={{ margin: "12px 0 6px 0" }}>
                        {totalMonthToMonth >= 0 ? (
                          <label style={{ color: "green", fontWeight: 550 }}>
                            +{totalMonthToMonth}
                          </label>
                        ) : (
                          <label style={{ color: "red", fontWeight: 550 }}>
                            {totalMonthToMonth}
                          </label>
                        )}
                        &nbsp;In this Month
                      </p>
                    </div>
                  </div>
                  <div className="wrapper-card-akumulasi">
                    <label className="label-text-bpb">a</label>
                    <div>
                      <p style={{ margin: "6px 0 12px 0" }}>On Review</p>
                      <p className="total-request-text">
                        {dataHeader && dataHeader.totalReview} Request
                      </p>
                      <p style={{ margin: "12px 0 6px 0" }}></p>
                    </div>
                  </div>
                  <div className="wrapper-card-akumulasi">
                    <label className="label-text-bpb">a</label>
                    <div>
                      <p style={{ margin: "6px 0 12px 0" }}>On Proccess</p>
                      <p className="total-request-text">
                        {dataHeader && dataHeader.totalProses} Request
                      </p>
                      <p style={{ margin: "12px 0 6px 0" }}></p>
                    </div>
                  </div>
                  <div className="wrapper-card-akumulasi">
                    <label className="label-text-bpb">a</label>
                    <div>
                      <p style={{ margin: "6px 0 12px 0" }}>Done</p>
                      <p className="total-request-text">
                        {dataHeader && dataHeader.totalDone} Request
                      </p>
                      <p style={{ margin: "12px 0 6px 0" }}></p>
                    </div>
                  </div>
                </div>
                <br />
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    {subMenu !== "review" ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          className="search_box_bpb"
                          type="text"
                          placeholder="Cari Nama Item"
                          value={valueSearchItemBpb}
                          onChange={(e) =>
                            setValueSearchItemBpb(e.target.value)
                          }
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <select
                      style={{ marginRight: "6px" }}
                      className="select-filter-bulan-tahun"
                      defaultValue="Bulan"
                      onChange={(e) => setFilterBulan(e.target.value)}
                      value={filterBulan}
                    >
                      <option selected disabled>
                        Bulan
                      </option>
                      {bulan.map((ele) => (
                        <option value={Number(ele.value)}>{ele.name}</option>
                      ))}
                    </select>
                    <select
                      className="select-filter-bulan-tahun"
                      defaultValue="Tahun"
                      onChange={(e) => setFilterTahun(e.target.value)}
                      style={{ marginRight: "6px" }}
                      value={filterTahun}
                    >
                      <option selected disabled>
                        Tahun
                      </option>
                      {tahun.map((ele) => (
                        <option value={ele}>{ele}</option>
                      ))}
                    </select>
                    <select
                      className="select-filter-bulan-tahun"
                      defaultValue="Bagian"
                      onChange={(e) => setFilterBagian(e.target.value)}
                      style={{ marginRight: "6px" }}
                      value={filterBagian}
                    >
                      <option selected={filterBagian === "Bagian"} disabled>
                        Bagian
                      </option>
                      {BagianConstant.map((ele) => (
                        <option value={ele.value}>{ele.name}</option>
                      ))}
                    </select>
                    <div
                      style={{
                        borderRadius: "4px",
                        marginRight: "12px",
                      }}
                    >
                      <button
                        className="button-reset-bpb"
                        onClick={() => setFilterBagian("Bagian")}
                      >
                        Reset
                      </button>
                    </div>
                    <img
                      src={RefreshIcon}
                      alt="refresh"
                      style={{
                        width: "30px",
                        height: "30px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setIsRefresh(true);
                      }}
                    />
                  </div>
                  {!isDireksi ? (
                    <div style={{ display: "flex", gap: "6px" }}>
                      <button
                        className="button_export_bulanan"
                        onClick={() => setPopUpCariBarang(true)}
                        style={{ minHeight: "32px", background: "#fe8c50" }}
                      >
                        Cari Barang
                      </button>

                      <button
                        className="button_export_bulanan"
                        onClick={() => handleExportBulananBpb()}
                        style={{ minHeight: "32px" }}
                      >
                        Export Bulanan
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    borderBottom: "1px solid lightgray",
                    height: "48px",
                    marginTop: "12px",
                  }}
                >
                  <p
                    className={
                      subMenu === "review"
                        ? "submenu-bpb-active"
                        : "submenu-bpb"
                    }
                    onClick={() => setSubMenu("review")}
                  >
                    Review
                  </p>
                  <p
                    className={
                      subMenu === "proccess"
                        ? "submenu-bpb-active"
                        : "submenu-bpb"
                    }
                    onClick={() => setSubMenu("proccess")}
                  >
                    Proccess
                  </p>
                  <p
                    className={
                      subMenu === "done" ? "submenu-bpb-active" : "submenu-bpb"
                    }
                    onClick={() => setSubMenu("done")}
                  >
                    Done
                  </p>
                </div>

                {dataFilterListBpb && dataFilterListBpb.length > 0 ? (
                  <div
                    style={{
                      marginTop: "12px",
                      background: "#e5f4d4",
                      borderRadius: "8px",
                      overflow: "scroll",
                    }}
                  >
                    <table
                      className="font10-mobile-bpb"
                      style={{
                        width: "100%",
                        borderSpacing: 0,
                        textAlign: "left",
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "8px 0px 8px 24px",
                            width: "10%",
                          }}
                        >
                          No.
                        </th>
                        <th style={{ width: "15%", padding: "8px" }}>
                          Tanggal
                        </th>
                        <th style={{ padding: "8px" }}>No. BPB</th>
                        <th style={{ padding: "8px" }}>Bagian</th>
                        <th style={{ padding: "8px" }}>Status</th>
                      </tr>
                      {dataFilterListBpb &&
                        dataFilterListBpb.map((data, index) => {
                          return (
                            <tr
                              style={
                                index % 2 === 0
                                  ? { background: "white", cursor: "pointer" }
                                  : { background: "#F7F7F7", cursor: "pointer" }
                              }
                            >
                              <td
                                style={{ padding: "8px 0px 8px 24px" }}
                                onClick={() => handlePickBpb(data)}
                              >
                                {index + 1}.
                              </td>
                              <td
                                style={{
                                  padding: "12px 8px",
                                }}
                                onClick={() => handlePickBpb(data)}
                              >
                                {moment(data.date)
                                  .utcOffset(7)
                                  .format("DD-MM-YYYY")}
                              </td>
                              <td
                                style={{ padding: "12px 8px" }}
                                onClick={() => handlePickBpb(data)}
                              >
                                {data.bpbNumber}
                              </td>
                              <td
                                style={{ padding: "12px 8px" }}
                                onClick={() => handlePickBpb(data)}
                              >
                                {data.dari.toUpperCase()}
                              </td>
                              <td
                                style={{ padding: "12px 8px" }}
                                onClick={() => handlePickBpb(data)}
                              >
                                {subMenu === "review"
                                  ? "Menunggu Approve"
                                  : subMenu === "proccess"
                                  ? "Sedang di Proses"
                                  : "Selesai"}
                              </td>
                              {subMenu === "review" && isFinance ? (
                                <td style={{ padding: "12px 8px" }}>
                                  <img
                                    className="img-delete-bpb"
                                    src={DeleteIcon}
                                    onClick={() => handleDeleteBpb(data.id)}
                                  />
                                </td>
                              ) : (
                                ""
                              )}
                            </tr>
                          );
                        })}
                    </table>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <label style={{ fontWeight: "550", fontSize: "18px" }}>
                    List Barang dan Jasa
                  </label>
                  <div style={{ display: "flex" }}>
                    <button
                      className="wrapper-button-tambah"
                      style={{
                        marginRight: "6px",
                        border: "none",
                        color: "white",
                      }}
                      onClick={() => setPopUpImport(true)}
                    >
                      Import List
                    </button>
                    <div
                      className="wrapper-button-tambah"
                      onClick={() => setPopUpTambahList(true)}
                    >
                      <p className="button-tambah">+</p>
                      <button className="text-button-tambah">
                        New Barang Jasa
                      </button>
                    </div>
                  </div>
                </div>
                <div className="wrapper-table-list">
                  <div className="table-list-barang-jasa">
                    <p style={{ margin: "0 0 12px 0" }}>List Barang</p>
                    <div style={{ display: "flex" }}>
                      <input
                        className="search_box_bpb"
                        type="text"
                        placeholder="Cari"
                        value={valueSearchBarang}
                        onChange={(e) => setValueSearchBarang(e.target.value)}
                      />
                      <p
                        className="btn_reset_search_bpb"
                        style={{ margin: "0 12px 12px 0" }}
                        onClick={() => setValueSearchBarang("")}
                      >
                        Reset
                      </p>
                      <img
                        src={RefreshIcon}
                        alt="refresh"
                        style={{
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setIsRefresh(true);
                        }}
                      />
                    </div>
                    <div style={{ height: "70vh", overflow: "scroll" }}>
                      <table
                        className="font10-mobile-bpb"
                        style={{
                          width: "100%",
                          borderSpacing: 0,
                          textAlign: "left",
                          borderRadius: "8px",
                          marginRight: "6px",
                          background: "#e5f4d4",
                        }}
                      >
                        <tr>
                          <th
                            style={{
                              padding: "8px",
                              width: "10%",
                            }}
                          >
                            No.
                          </th>
                          <th style={{ padding: "8px" }}>Nama Barang</th>
                          <th style={{ padding: "8px" }}></th>
                        </tr>
                        {sortDataBarang &&
                          sortDataBarang.map((data, index) => {
                            return (
                              <tr
                                style={
                                  index % 2 === 0
                                    ? { background: "white" }
                                    : { background: "#F7F7F7" }
                                }
                              >
                                <td
                                  style={{ padding: "8px", fontSize: "14px" }}
                                >
                                  {index + 1}.
                                </td>
                                <td
                                  style={{
                                    padding: "8px 8px",
                                    fontSize: "14px",
                                  }}
                                >
                                  {data.value}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  <button
                                    className="button-delete-list"
                                    onClick={() =>
                                      handleDelete(data.value, "barang")
                                    }
                                  >
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </table>
                    </div>
                  </div>
                  <div className="table-list-barang-jasa">
                    <p style={{ margin: "0 0 12px 0" }}>List Jasa</p>
                    <div style={{ display: "flex" }}>
                      <input
                        className="search_box_bpb"
                        type="text"
                        placeholder="Cari"
                        value={valueSearchJasa}
                        onChange={(e) => setValueSearchJasa(e.target.value)}
                      />
                      <p
                        className="btn_reset_search_bpb"
                        style={{ margin: "0 12px 12px 0" }}
                        onClick={() => setValueSearchJasa("")}
                      >
                        Reset
                      </p>
                      <img
                        src={RefreshIcon}
                        alt="refresh"
                        style={{
                          width: "30px",
                          height: "30px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setIsRefresh(true);
                        }}
                      />
                    </div>
                    <div style={{ height: "70vh", overflow: "scroll" }}>
                      <table
                        className="font10-mobile-bpb"
                        style={{
                          width: "100%",
                          borderSpacing: 0,
                          textAlign: "left",
                          borderRadius: "8px",
                          marginRight: "6px",
                          background: "#e5f4d4",
                        }}
                      >
                        <tr>
                          <th
                            style={{
                              padding: "8px",
                              width: "10%",
                            }}
                          >
                            No.
                          </th>
                          <th style={{ padding: "8px" }}>Nama Jasa</th>
                          <th style={{ padding: "8px" }}></th>
                        </tr>
                        {sortDataJasa &&
                          sortDataJasa.map((data, index) => {
                            return (
                              <tr
                                style={
                                  index % 2 === 0
                                    ? { background: "white" }
                                    : { background: "#F7F7F7" }
                                }
                              >
                                <td
                                  style={{ padding: "8px", fontSize: "14px" }}
                                >
                                  {index + 1}.
                                </td>
                                <td
                                  style={{
                                    padding: "8px 8px",
                                    fontSize: "14px",
                                  }}
                                >
                                  {data.value}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  <button
                                    className="button-delete-list"
                                    onClick={() =>
                                      handleDelete(data.value, "jasa")
                                    }
                                  >
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </table>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      </div>
    </>
  );
};
export default Bpb;
